import { render, staticRenderFns } from "./Languages.vue?vue&type=template&id=19092561&scoped=true"
import script from "./Languages.vue?vue&type=script&lang=js"
export * from "./Languages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19092561",
  null
  
)

export default component.exports